import router from '@/modules/router'
import policies from '@/modules/mixins/policies'

export default {
    mixins: [policies],
    data() {
        return {
            psw: null,
            acceptTerms: false,
            acceptPrivacy: false,
            loading: false,
            model: {
                accepted_terms_version: 1,
                accepted_privacy_version: 1,
                is_subscribed_for_newsletter: false,
            },
        }
    },
    mounted() {
        this.$set(this.model, 'accepted_privacy_version', this.config.privacy_version)
        this.$set(this.model, 'accepted_terms_version', this.config.terms_version)
    },
    methods: {
        async register(navigate = true) {
            try {
                this.loading = true
                await this.$user.register(this.model)
                try {
                    await this.$user.login({
                        email: this.model.email,
                        password: this.model.plain_password,
                    })
                    if (navigate)
                        router.push({
                            name: 'restaurant-list',
                        })
                    return Promise.resolve()
                } catch (e) {
                    if (navigate) router.push({ name: 'login' })
                    return Promise.reject(e)
                }
            } catch (e) {
                return Promise.reject(e)
            } finally {
                this.loading = false
            }
        },
    },
}
